import React from "react";
import { makeStyles, createStyles, Theme, useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import WhiteTextBoxWithAdornments from "components/textBoxes/whiteTextBox/WhiteTextBoxWithAdornments";
import Typography from "@material-ui/core/Typography";
import { PaperProps } from "@material-ui/core/Paper";
import { fonts } from "theme";
import RandomRotate from "components/rotate/RandomRotate";
import DialogCloseButton from "../DialogCloseButton";

const useStyles = makeStyles((theme: Theme) => {
    return createStyles({
        root: {
            maxWidth: 600,
            marginRight: 30,
            [theme.breakpoints.down("sm")]: { boxSizing: "border-box" },
        },
        title: {
            padding: "3px 12px",
            backgroundColor: theme.palette.background.default,
            color: theme.palette.common.white,
            textTransform: "uppercase",
            fontWeight: 900,
            fontSize: "2.5rem",
            lineHeight: "2.5rem",
            fontFamily: fonts.secondary,
            [theme.breakpoints.down("sm")]: {
                fontSize: "2rem",
                lineHeight: "2rem",
            },
            [theme.breakpoints.down("xs")]: {
                fontSize: "1.5rem",
                lineHeight: "1.5rem",
            },
        },
        closeButton: {
            position: "absolute",
            bottom: -13,
            right: -22,
        },
        icon: {
            marginRight: 50,
        },
        textBoxChildContainer: {
            marginTop: theme.spacing(1),
            maxHeight: "80vh",
            overflowY: "auto",
            overflowX: "hidden",
            "@media (max-height: 700px)": {
                maxHeight: "75vh",
            },
            "@media (max-height: 600px)": {
                maxHeight: "70vh",
            },
            "@media (max-height: 500px)": {
                maxHeight: "65vh",
            },
            "@media (max-height: 400px)": {
                maxHeight: "60vh",
            },
        },
    });
});

export interface IPlaceholderPaperProps extends PaperProps {
    title?: string;
    onClose?: () => void;
}

export default function PlaceholderPaper(props: IPlaceholderPaperProps) {
    const classes = useStyles();
    const { title, onClose = () => {}, children } = props;

    const theme = useTheme();
    const xsScreen = useMediaQuery(theme.breakpoints.down("sm"));

    const textBox = (
        <WhiteTextBoxWithAdornments
            className={classes.root}
            titlePrefixComponent={
                typeof title === "undefined" ? undefined : (
                    <div style={{ display: "flex" }}>
                        <Typography className={classes.title}>{title}</Typography>
                    </div>
                )
            }
            titleSuffixComponent={
                <div>
                    <DialogCloseButton onClick={() => onClose()} />
                </div>
            }
            classes={{
                titleSuffix: classes.closeButton,
                icon: classes.icon,
            }}
            textContainerClasses={{ childContainer: classes.textBoxChildContainer }}
        >
            {children}
        </WhiteTextBoxWithAdornments>
    );

    return xsScreen ? (
        textBox
    ) : (
        <RandomRotate min={1.5} max={2.5}>
            {textBox}
        </RandomRotate>
    );
}
